import { baseApi } from './baseApi';

export const pointsMonitorApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    // Get points overview stats
    getPointsStats: builder.query({
      query: () => '/points-monitor/stats',
      providesTags: ['PointsStats'],
    }),

    // Get users with points list with pagination
    getPointsUsers: builder.query({
      query: (params) => ({
        url: '/points-monitor/users',
        params,
      }),
      providesTags: ['PointsUsers'],
    }),

    // Get single user points details
    getUserPointsDetails: builder.query({
      query: (id) => `/points-monitor/users/${id}`,
    }),

    // Get point conversions history
    getConversions: builder.query({
      query: (params) => ({
        url: '/points-monitor/conversions',
        params,
      }),
      providesTags: ['Conversions'],
    }),

    // Get conversion trend over time
    getConversionTrend: builder.query({
      query: (days = 30) => ({
        url: '/points-monitor/conversion-trend',
        params: { days },
      }),
    }),
  }),
});

export const {
  useGetPointsStatsQuery,
  useGetPointsUsersQuery,
  useGetUserPointsDetailsQuery,
  useGetConversionsQuery,
  useGetConversionTrendQuery,
} = pointsMonitorApi;
